<template>
  <div>
    <h3 class="font-semibold text-init mt-0 mb-4 leading-6">
      {{ title }}
    </h3>
    <div class="more-checkbox__wrapper">
      <div
        v-for="option in slicedOptions"
        :key="option.id"
        class="more-checkbox pr-0.5"
      >
        <div>
          <CheckboxField
            size="large"
            class="more-checkbox__checkbox"
            :label="option.infoTooltip ? null : option.label"
            :model-value="values[option.id] || false"
            @update:modelValue="$emit('change', { option, value: $event })"
          >
            <div v-if="option.infoTooltip" class="flex">
              <span class="ds-checkbox-text">{{ option.label }}</span>
              <Tooltip :text="option.infoTooltip" class="ml-1 mt-1" position="top-right">
                <InfoCircleIcon class="w-4 h-4" />
              </Tooltip>
            </div>
          </CheckboxField>
        </div>
      </div>
    </div>
    <a
      v-show="!showMore && options.length > elementsToShowByDefault"
      class="font-bold cursor-pointer inline-block mt-2"
      @click="showMore = true"
    >
      + Show all
      <span v-if="hiddenSelectedElements">({{ hiddenSelectedElements }})</span>
    </a>
  </div>
</template>

<script>
import PlusIcon from '@tagvenue/icons/24/bold/general/plus.svg';
import InfoCircleIcon from '@tagvenue/icons/24/line/general/info-circle.svg';
import { markRaw } from 'vue';

import CheckboxField from '@/components/Ui/Forms/CheckboxField.vue';
import Tooltip from '@/components/Ui/Tooltip.vue';

export default {
  name: 'MoreSection',
  emits: ['change'],
  components: {
    CheckboxField, InfoCircleIcon, Tooltip,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      PlusIcon: markRaw(PlusIcon),
      showMore: false,
      elementsToShowByDefault: 4,
    };
  },
  computed: {
    slicedOptions() {
      if (this.showMore) {
        return this.options;
      }
      return this.options.slice(0, this.elementsToShowByDefault);
    },
    hiddenSelectedElements() {
      const options = this.options.slice(this.elementsToShowByDefault);
      return options.reduce((acc, option) => acc + (this.values[option.id] ? 1 : 0), 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/base/variables";

.more-checkbox {
  margin: 8px 0;
  flex-basis: 50%;

  @media only screen and (max-width: variables.$screen-xs-max) {
    flex-basis: 100%;
  }
}

.more-checkbox__wrapper {
  display: flex;
  flex-flow: row wrap;
}

.more-checkbox__checkbox {
  align-items: start;

  :deep(.ds-checkbox-text) {
    padding-top: 2px;
  }
}
</style>
